<template>
  <div id="app">
    <div class="app-widget">

      <Preloader v-if="isLoading"/>

      <transition name="fade">
        <div class="popup" v-if="errorMessage">
          <div class="popup__inner">
            <div class="popup__close">
              <img src="../../public/img/telemedicine-widget-images/cross.svg" @click="closePopup">
            </div>
            <div class="popup__title">Запись возможна только на повторную консультацию врача после первичного приема в клинике. Если вам нужна первичная консультация, диагностика или процедура, то запись доступна по телефону <a href="tel:+7(495)790-35-53" class="link">+7(495)790-35-53</a></div>
            <div class="popup__text">{{errorMessage}}</div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="wrapper">
          <div class="app-widget__inner">
            <div class="app-widget__top">
              <div class="app-widget__top-wrap">
                <h1 class="app-widget__title">Запись на ОНЛАЙН консультацию</h1>
                <div class="app-widget__text">
                  Запись возможна только на повторную консультацию врача после первичного приема в клинике. Если вам нужна первичная консультация, диагностика или процедура, то запись доступна по телефону
                  <a :href="'tel:' + phone" class="app-widget__text-link">{{phone}}</a>
                </div>
              </div>
              <div class="app-widget__step">
                <span>шаг {{stepCount}}</span> из 3
              </div>
            </div>
            <transition name="fade">
              <step-one
                      :userData="userData"
                      v-if="stepCount === 1"
                      @sendUserData="fetchUserData"/>
            </transition>
            <transition name="fade">
              <step-two
                      v-if="userData.P_JWT && dictionaryData && !formIsApproved"
                      :dictionaryData="dictionaryData"
                      :selectedData="selectedData"
                      :dateAndPricing="dateAndPricing"
                      :phoneNumber="phoneNumber"
                      :getSms="getSms"
                      :repeatPhone="repeatPhone"
                      @updatePhone="updatePhone"
                      @updateCode="updateCode"
                      @updateEmail="updateEmail"
                      @lastFilter="lastFilter"
                      @allFiltersSelected="filterHasChanged"
                      @resetAll='resetAll'
                      @createAppointment="createAppointment"
                      @confirmCode="confirmCode"
                      @repeatSms="repeatSms"
                      @approvePhoneAgaine="approvePhoneAgaine"
              />
            </transition>
            <transition name="fade">
              <step-three
                      v-if="formIsApproved"
                      :userData="userData"
                      :selectedData="selectedData"
                      :appointmentId="appointmentId"
                      :dateAndPricing="dateAndPricing"
              />
            </transition>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import StepOne from '../components/step-one';
import StepTwo from '../components/step-two';
import StepThree from '../components/step-three';
import Preloader from '../components/Preloader';
import UserService from '../services/api.service';
import moment from 'moment';

export default {
  name: 'Home',
  components: {
    StepOne,
    StepTwo,
    StepThree,
    Preloader
  },
  data() {
    return {
      phone: window.TELEMEDICINE_PHONE,
      stepCount: 1,
      isLoading: false,
      userData: {
        patientName: '',
        patientSurname: '',
        patientPatronymic: '',
        patientBirthDate: '',
        P_JWT: ''
      },
      dictionaryData: null,
      selectedData: {
        clinics: null,
        doctors: null,
        services: null,
        date: null,
        timeslot: null
      },
      dateAndPricing: {
        date: null,
        price: 0,
        times: []
      },
      requestParam: {
        isReady: false,
        data: {}
      },
      lastFiltered: null,
      phoneNumber: '',
      email: '',
      getSms: true,
      smsCode: null,
      appointmentId: null,
      formIsApproved: false,
      repeatPhone: false,
      isEnd: true,
      errorMessage: null
    }
  },
  methods: {
    fetchUserData() {
      const data = {
        firstName: this.userData.patientName,
        lastName: this.userData.patientSurname,
        middleName: this.userData.patientPatronymic,
        dateOfBirth: this.userData.patientBirthDate
      };

      this.isLoading = true;

      UserService.findPatient(data)
          .then(res => {
            this.userData.P_JWT = res.data;

            localStorage.setItem('P_JWT', res.data);

            this.fetchFormData();
           })
          .catch(err => {
            this.errorMessage = err.response.data.message;
            this.isLoading = false;
          });
    },
    fetchFormData() {
      this.isLoading = true;

      UserService.getDictionaries(this.requestParam.data)
        .then(res => {
          this.dictionaryData = res.data;
          for (let property in res.data) {
            if (res.data[property].length === 1) {
              this.setInitialFilter(res.data[property][0],property);
            }
          }
          this.isLoading = false;
          this.stepCount = 2;
        })
        .catch(err => {
          this.errorMessage = err.response.data.message;
          this.isLoading = false;
        })
    },
    resetAll() {
      this.selectedData = {
        clinics: null,
        doctors: null,
        services: null,
        date: null,
        timeslot: null,
      };
      this.requestParam = {
        isReady: false,
        data: {}
      };
      this.dateAndPricing = {
        date: null,
        price: 0,
        times: []
      };
      this.fetchFormData();
    },
    setInitialFilter(value,type) {
      this.selectedData[type] = value;
    },
    filterHasChanged() {
      this.preventDoubleSelection();

      this.setRequestParam();

      if (this.requestParam.isReady) {
        this.fetchTimeSlots();
      }

      this.formatDate();
      this.fetchFormData();
    },
    fetchTimeSlots() {
      this.isLoading = true;

      UserService.getTimeSlot(this.requestParam.data)
        .then(res => {
          const noData = {
            date: null,
            price: 0,
            times: []
          };
          this.dateAndPricing = res.data[0] ? res.data[0] : noData;
          this.isLoading = false;
        })
        .catch(err => {
          this.errorMessage = err.response.data.message;
          this.isLoading = false;
        })
    },
    setRequestParam() {
      this.requestParam.data = {};
      const keys = Object.keys(this.selectedData);
      const objectKeys = ['clinicId','doctorId','serviceId','date'];
      let count = 0;

      for (let i = 0; i < 4; i++) {
        if (this.selectedData[keys[i]] !== null && i < 3) {
          this.requestParam.data[objectKeys[i]] = this.selectedData[keys[i]].id;
          count++;
        } else if (this.selectedData[keys[i]] !== null && i === 3) {
          this.requestParam.data[objectKeys[i]] = this.selectedData[keys[i]];
          count++;
        }
      }
      this.requestParam.isReady = (count === 4);
    },
    lastFilter(field) {
      this.lastFiltered = field;
    },
    preventDoubleSelection() {
      if (this.selectedData.doctors === null &&
          this.dictionaryData.doctors.length === 1 ||
          this.selectedData.services === null &&
          this.dictionaryData.services.length === 1 ||
          this.lastFiltered === 'services' &&
          this.lastFiltered === 'doctors'
      ) {
        this.selectedData.services = null;
        this.selectedData.doctors = null;
        this.lastFiltered = null;
        this.dateAndPricing = {
          date: null,
          price: 0,
          times: []
        };
      }
    },
    updatePhone(val) {
      this.phoneNumber = val;
    },
    updateEmail(val) {
      this.email = val;
    },
    createAppointment() {
      this.isLoading = true;
      const appointmentForm = {
        clinicId: this.selectedData.clinics.id,
        doctorId: this.selectedData.doctors.id,
        serviceId: this.selectedData.services.id,
        anotherPatient: true,
        contactPhone: this.phoneNumber,
        comment: '',
        timeSlot: {
          time: this.selectedData.timeslot.time,
          duration: this.selectedData.timeslot.duration
        },
        metrics: [
          {
            metric: '',
            value: ''
          }
        ]
      };

      UserService.createAppointment(appointmentForm)
        .then(res=> {
          localStorage.setItem('appointmentId', res.data.appointmentId);
          this.appointmentId = res.data.appointmentId;
          this.approvePhone();
        })
        .catch(err => {
          this.errorMessage = err.response.data.message;
          this.isLoading = false;
        })
    },
    approvePhone() {
      this.isLoading = true;
      const requestData = {
        appointmentId: this.appointmentId,
        phone: this.phoneNumber,
        email: this.email
      };
      UserService.sendConfirmation(requestData)
        .then(() => {
          this.getSms = false;
          this.isLoading = false;
        })
        .catch(err => {
          this.errorMessage = err.response.data.message;
          this.isLoading = false;
        })
    },
    updateCode(val) {
      this.smsCode = val;
    },
    confirmCode() {
      this.isLoading = true;
      UserService.confirmCode({ appointmentId: this.appointmentId, code: this.smsCode })
        .then(() => {
          this.isLoading = false;

          if (this.dateAndPricing.price === 0) {
            this.$router.push({ path: `/approved/${this.appointmentId}` });
          } else {
            this.stepCount++;
            this.formIsApproved = true;
          }
        })
        .catch(err => {
          this.errorMessage = err.response.data.message;
          this.isLoading = false;
        })
    },
    repeatSms() {
      this.getSms = !this.getSms;
    },
    approvePhoneAgaine() {
      this.approvePhone();
      this.getSms = !this.getSms;
    },
    formatDate() {
      if (this.selectedData.timeslot) {
        const date = moment(this.selectedData.timeslot.time).format('DD.MM.YYYY');
        const time = moment(this.selectedData.timeslot.time).format('HH:mm');
        return `${date} в ${time}`;
      }
    },
    closePopup() {
      this.errorMessage = null;
    }
  }
}
</script>

<style lang="sass">
  body
    margin: 0
    background: #f8f8f8
    .wrapper
      max-width: 1400px
      margin: 0 auto

    .app-widget
      position: relative
      *
        box-sizing: border-box

</style>

<style lang="sass">
  .fade-enter-active
    transition: all .3s ease
    transition-delay: .3s

  .fade-leave-active
    transition: all .3s ease

  .fade-enter, .fade-leave-to
    opacity: 0

  .app-widget
    margin: 20px 0 45px
    color: #3a3a3a
    font-size: 16px
    font-family: 'Roboto'
    height: 100%

    .wrapper
      padding: 0

    .age-picker__error
      color: red
      margin-top: 8px
      font-size: 13px

    .age-picker,
    .success-form-popup
      position: fixed
      display: flex
      justify-content: center
      align-items: center
      top: 0
      right: 0
      left: 0
      bottom: 0
      z-index: 99
      background: rgba(#000, .15)
      &__form
        display: flex
        .button
          margin-left: 10px
      &__inner
        max-width: 380px
        width: 100%
        padding: 50px
        background: #fff
      &__title
        font-size: 21px
        font-weight: 500
        margin-bottom: 25px

    &__inner
      box-shadow: 0 3px 4px rgba(0, 0, 0, 0.06)
      background-color: #ffffff
      padding: 50px 40px

    &__title
      font-size: 30px
      font-weight: 700
      text-transform: uppercase
      margin-bottom: 25px

    &__subtitle
      max-width: 600px
      font-size: 15px
      line-height: 1.5
      margin-bottom: 50px
      a
        color: #1bb3b2
        text-decoration: none

    &__top
      display: flex
      justify-content: space-between
      align-items: baseline

    &__step
      margin: 0 0 0 30px
      font-size: 18px
      line-height: 130%
      text-transform: uppercase
      color: #222

      span
        font-weight: bold
        color: #139594

    &__text
      max-width: 745px
      margin: 33px 0 0
      font-size: 14px
      line-height: 140%
      color: #222

      &-link
        font-weight: bold
        color: #222
        text-decoration: unset
        transition: .3s ease-in-out

        &:hover
          color: #14aead

    &__head
      border-bottom: 1px solid #14aead
      padding-bottom: 40px
      margin: 40px 0

    &__foot
      border-top: 1px solid #eeeeee
      padding-top: 70px
      margin-top: 60px

    &__submit
      display: flex
      align-items: center

      .button
        margin-right: 80px
        padding-left: 60px!important
        padding-right: 60px!important

      .terms
        color: #a6a6a6
        font-size: 15px

    .success-form-popup
      font-size: 18px
      &__inner
        display: flex
        max-width: 450px
        width: 100%
      .button
        margin-left: 20px

    .head-selection
      display: flex
      align-items: flex-end
      &__item
        width: 25%
        display: flex
        margin-right: 80px
        &:last-child
          margin-right: 0
        &--clear
          justify-content: flex-end
          margin-left: auto

    .body-selection
      display: flex
      &__label
        font-size: 18px
        font-weight: 500
        text-transform: uppercase
        margin-bottom: 25px
        display: flex
      &__clear
        cursor: pointer
        margin: 2px 5px 0 15px
        img
          width: 12px
          height: 12px
          margin-bottom: 3px

      &__item
        width: 25%
        max-width: 260px
        margin-right: 60px

        &--date
          max-width: unset

        &--clinics
          display: none

        &:last-child
          margin-right: 0

    .time-to-visit
      display: flex
      flex-direction: column
      align-items: flex-start
      &__label
        font-size: 14px
        font-weight: 500
        margin-bottom: 10px
      &__value
        display: flex
        color: #282828
        font-size: 22px
        font-weight: 300
        border-bottom: 1px dotted #bfbfbf
        padding-bottom: 3px
      &__result
        display: flex
        align-items: center
      &__clear
        cursor: pointer
        margin-left: 12px
        img
          width: 12px
          height: 12px
          margin-bottom: 3px

    .reset-all
      cursor: pointer
      color: #1bb3b2

    @media screen and (max-width: 1150px)
      .app-widget
        &__inner
          padding-left: 20px
          padding-right: 20px
      .body-selection
        &__item
          width: auto
          margin-right: 40px

      .time-to-visit
        &__value
          font-size: 18px

      .head-selection
        justify-content: space-between
        &__item
          width: auto
          margin-right: 30px

    @media screen and (max-width: 950px)
      .app-widget
        &__top
          flex-direction: column
        &__step
          margin: 30px 0 0
      .body-selection
        flex-wrap: wrap
        justify-content: space-between
        &__item
          width: calc(50% - 20px)
          max-width: 100%
          margin-right: 0
          margin-bottom: 35px

    @media screen and (max-width: 700px)
      .head-selection__item:not(.head-selection__item--clear)
        display: none
      .body-selection__item--clinics
        display: block

    @media screen and (max-width: 650px)
      .body-selection
        &__item
          width: 100%
          &:last-child
            margin-bottom: 0

    @media screen and (max-width: 600px)
      .app-widget__submit
        flex-direction: column
        .terms
          order: -1
          font-size: 13px

        .button
          margin-top: 25px
          margin-right: 0

    @media screen and (max-width: 480px)
      .app-widget
        &__inner
          padding-left: 15px
          padding-right: 15px

        &__title
          font-size: 24px
        &__head
          margin-bottom: 35px
          padding-bottom: 20px

      .age-picker
        padding: 20px
        &__inner
          padding: 40px 20px!important

        &__title
          font-size: 18px!important
        &__form
          input
            font-size: 15px!important
            padding-left: 15px!important
            padding-right: 15px!important
            &::placeholder
              font-size: 15px!important

</style>

<style lang="sass" scoped>
  .popup
    position: fixed
    display: flex
    align-items: center
    justify-content: center
    top: 0
    right: 0
    left: 0
    bottom: 0
    z-index: 999
    background: none!important
    &__title
      text-align: center
      font-size: 18px
      line-height: 1.4
      font-weight: bold
      margin-bottom: 25px
      a
        color: #1bb3b2
        text-decoration: none
    &__text
      color: red
      text-align: center

    &__inner
      max-width: 450px
      position: relative
      margin: 0 auto
      width: 100%
      background: #fff
      padding: 45px
      box-shadow: 0px 0px 35px 0px rgba(0,0,0,0.2)

    &__close
      position: absolute
      top: 20px
      right: 20px
      img
        width: 16px
        height: 16px
        cursor: pointer
</style>
